import Vue from 'vue';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
import axios from 'axios';
import VueMeta from 'vue-meta';
import VueGtag from 'vue-gtag';

import '@/styles/global.scss';

Vue.config.productionTip = false;

Vue.prototype.$http = axios;

Vue.use(VueMeta);

Vue.use(
  VueGtag,
  {
    config: { id: 'G-FZC3BSGS70' }
  },
  router // Insert vue router
);

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app');
